"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../../../gen-src/Localize");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var ComposeEmailDialogStyles_1 = require("./ComposeEmailDialogStyles");
/**
 * current design calls for no red border after editing, so 'empty' is just grey (but submit is still disabled)
 * current design calls for no green border, so 'valid' is just grey
 */
function isTextValid(validity) {
    switch (validity) {
        case 'overflow': return false;
        case 'empty': return undefined;
        case 'valid': return undefined;
        case 'initial': return undefined;
        default:
            TypescriptHelpers_1.assertUnreachable(validity);
            return undefined;
    }
}
function getSubjectMessage(props) {
    if (props.subjectValidity === 'overflow') {
        return Localize_1.Messages.CharacterLimitExceeded({
            total: Localize_1.Formatters.formatCount(props.subjectText.length),
            maximum: Localize_1.Formatters.formatCount(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_SUBJECT_LENGTH)
        });
    }
    return Localize_1.Messages.CharacterCounter({
        characters: Localize_1.Formatters.formatCount(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_SUBJECT_LENGTH - props.subjectText.length)
    });
}
function getBodyMessage(props) {
    if (props.bodyValidity === 'overflow') {
        return Localize_1.Messages.CharacterLimitExceeded({
            total: Localize_1.Formatters.formatCount(props.bodyText.length),
            maximum: Localize_1.Formatters.formatCount(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_BODY_LENGTH)
        });
    }
    return Localize_1.Messages.CharacterCounter({
        characters: Localize_1.Formatters.formatCount(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_BODY_LENGTH - props.bodyText.length)
    });
}
function ComposeEmailDialogFooter(props) {
    var cancelButtonProps = {
        testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('cancel-button'),
        handleClick: props.dismissDialog,
        buttonType: widgets_1.ButtonType.Outline,
        children: Localize_1.Messages.Cancel(),
        disabled: props.isSubmitting,
    };
    var submitButtonProps = {
        testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('send-button'),
        handleClick: props.invokeSubmit,
        buttonType: widgets_1.ButtonType.Primary,
        children: Localize_1.Messages.Send(),
        disabled: props.isSubmitting || !props.isValid,
        style: props.isSubmitting ? ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.buttonStyleSubmitting : {},
        getContent: function (_) {
            return (props.isSubmitting ? (React.createElement("div", { style: { marginTop: widgets_1.TabStyles.Spacing.SmallSpace } },
                React.createElement(widgets_1.ActivitySpinnerWidget, { spinnerSize: widgets_1.ActivitySpinnerSize.Small, testId: '' }))) :
                React.createElement("span", null, Localize_1.Messages.Send()));
        }
    };
    return (React.createElement(widgets_1.DialogFooterButtonsWidget, { testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('footer-buttons'), buttons: [
            cancelButtonProps,
            submitButtonProps,
        ] }));
}
exports.ComposeEmailDialogFooter = ComposeEmailDialogFooter;
function ComposeEmailDialogContent(props) {
    var subjectFieldProps = {
        kind: 'outline',
        label: Localize_1.Messages.EmailSubjectLabel(),
        testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('subject-text-field')
    };
    var userCount = Object.keys(props.selectedUserIds).length;
    return (React.createElement(React.Fragment, null,
        React.createElement(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.LabelTextDiv, { style: { paddingTop: 0 } }, Localize_1.Messages.To()),
        React.createElement(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.RecipientsDiv, null, 
        // TODO: this needs to get turned into pills of user names
        Localize_1.Messages.NumberOfRecipients({
            USER_COUNT: userCount,
            USER_COUNT_LOC: Localize_1.Formatters.formatCount(userCount)
        })),
        React.createElement(widgets_1.TextFieldWidget, __assign({ className: typestyle_1.classes(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.subjectContainer), message: getSubjectMessage(props), onChange: props.handleSubjectChange, placeholder: Localize_1.Messages.EmailSubjectLabel(), style: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.subjectStyle, valid: isTextValid(props.subjectValidity), value: props.subjectText }, subjectFieldProps)),
        React.createElement(widgets_1.TextAreaWidget, { label: (React.createElement(ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.LabelTextDiv, null, Localize_1.Messages.EmailMessageLabel())), onChange: props.handleBodyChange, className: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.messageAreaClass, testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('text-area'), style: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.messageAreaStyle, valid: isTextValid(props.bodyValidity), message: getBodyMessage(props) })));
}
exports.ComposeEmailDialogContent = ComposeEmailDialogContent;
//# sourceMappingURL=ComposeEmailDialogContent.js.map